module.exports = __webpack_public_path__ + "img/icon15.1168899b.png";